import type { IItem } from "@Front/Components/DesignSystem/Menu/MenuItem";

function attachExitToLeafLinks(
	item: IItem,
	exitGuestThenNavigate: (nextHref: string) => Promise<boolean>,
): IItem {
	if ("dropdown" in item && item.dropdown) {
		return {
			...item,
			dropdown: {
				...item.dropdown,
				items: item.dropdown.items.map((sub) => attachExitToLeafLinks(sub, exitGuestThenNavigate)),
			},
		};
	}
	if (!("link" in item) || typeof item.link !== "string" || item.link.length === 0) {
		return item;
	}
	return {
		...item,
		beforeLinkNavigate: async (nextHref: string): Promise<boolean> => exitGuestThenNavigate(nextHref),
	};
}

/**
 * Attache `beforeLinkNavigate` sur chaque entrée à lien direct (menu Espace office), y compris sous-menus.
 */
export function attachGuestExitBeforeNavigateToOfficeMenuLinks(
	items: IItem[],
	exitGuestThenNavigate: (nextHref: string) => Promise<boolean>,
): IItem[] {
	return items.map((item) => attachExitToLeafLinks(item, exitGuestThenNavigate));
}
